/**
 * PJO rejection — user must choose refund / change flight before deadline.
 */

const isRejectedByPjoStatus = (status) =>
  status === 'RejectedByPJO' || status === 'rejected_by_pjo';

export const isRejectedByPjoBooking = (booking) => {
  if (!booking) return false;
  if (isRejectedByPjoStatus(booking.booking_status)) return true;
  if (isRejectedByPjoStatus(booking.acceptance_status)) return true;
  if (booking.flights?.some((leg) => isRejectedByPjoStatus(leg.booking_status))) {
    return true;
  }
  if (booking.requires_pjo_rejection_choice || booking.pjo_rejection_choice_pending) {
    return true;
  }
  return false;
};

/**
 * Change-flight search after PJO rejection (choice submitted or still pending).
 */
export const isPjoRejectionRebookFlow = (booking, searchParams = null) => {
  if (isRejectedByPjoBooking(booking)) return true;

  if (searchParams) {
    const flag = searchParams.get('pjo_rejection');
    if (flag === '1' || flag === 'true') return true;
  }

  if (booking?.pjo_rejection_waiver || booking?.pjo_rejection_pending) {
    return true;
  }

  return false;
};
